import React, { FC } from 'react';
import { modalRoutes } from 'constants/routes';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';
import ModalRoute, { ModalRouteProps } from 'context/ModalRouter';
import { AssociateProfileModal } from 'app/modules/posts/components/PostsAssociateProfileModal';

// Settings has no network grid (`#new-profile`) to add more profiles from.
const SettingsAssociateProfileModal: FC<ModalRouteProps> = (props) => (
  <AssociateProfileModal {...props} hasNetworkGrid={false} />
);

type Props = {};

const SettingsModals: FC<Props> = (props) => {
  return (
    <>
      <UserPermissionGate scopes={UserPermission.PAGE_CREATE}>
        <ModalRoute
          path={modalRoutes.ASSOCIATE_POSTS_PROFILE}
          component={SettingsAssociateProfileModal}
        />
      </UserPermissionGate>
    </>
  );
};

export default SettingsModals;
